module.exports = __webpack_public_path__ + "img/8.8e304970.jpg";